const TabContent = ({ activeKey, content }) => {
  return (
    <div className="mt-3">
      {/* {Object.keys(content).map((key) => (
        <div
          key={key}
          style={{ display: activeKey === key ? "block" : "none" }}
        >
          {content[key]}
        </div>
      ))} */}
      {content(activeKey)}
    </div>
  );
};

export default TabContent;
